// Number formatting shared by the HUD and the flow screens. Formatters are built once; formatting only runs on
// change-driven updates.

import { SIM_HZ } from '@taxwar/net'

const WHOLE = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })
const ONE_DECIMAL = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
const TWO_DECIMALS = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const SIGNED_ONE_DECIMAL = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: 'always' })
const SECONDS_PER_MINUTE = 60
const CLOCK_SECONDS_DIGITS = 2

/** Treasury amounts are $M (content ECONOMY). */
export function formatMoney(millions: number): string {
  return `$${WHOLE.format(Math.floor(millions))}M`
}

export function formatMoneyRate(millionsPerSec: number): string {
  return `$${ONE_DECIMAL.format(millionsPerSec)}M/s`
}

export function formatSignedRate(perSec: number): string {
  return `${SIGNED_ONE_DECIMAL.format(perSec)}/s`
}

export function formatMultiplier(multiplier: number): string {
  return `×${TWO_DECIMALS.format(multiplier)}`
}

export function formatWhole(value: number): string {
  return WHOLE.format(value)
}

/** m:ss for a whole number of seconds (negative clamps to 0:00). */
export function formatClock(totalSeconds: number): string {
  const clamped = Math.max(0, totalSeconds)
  const minutes = Math.floor(clamped / SECONDS_PER_MINUTE)
  const seconds = clamped % SECONDS_PER_MINUTE
  return `${minutes}:${String(seconds).padStart(CLOCK_SECONDS_DIGITS, '0')}`
}

/** Whole seconds of sim time covering `ticks` (rounded up, so a clock never reads 0:00 while time remains). */
export function ticksToWholeSeconds(ticks: number): number {
  return Math.ceil(ticks / SIM_HZ)
}
